import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'badgeCount',
    standalone: false
})
export class BadgeCountPipe implements PipeTransform {
  public transform(value: number): string {
    if (!value || value <= 9) return (value || '').toString()
    return '+9'
  }
}
